import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import * as types from '../../constants/index';
import { TeamCalendarWidgetWrapper } from './styles';
import CalendarRow from '../../components/CalendarRow';
import Label from '../../components/shared/Label';
import StandingButton from '../../components/shared/StandingButton';
import { prettyTeamUrl } from '../../common/rcs_gaz_mc_core_FE';

class TeamCalendarWidget extends Component {
  static childContextTypes = {
    breakpoints: PropTypes.arrayOf(PropTypes.number),
  };

  constructor(props) {
    super(props);
    this.state = {
      isMobile: false,
    };
  }

  getChildContext = () => ({
    breakpoints: [320, 600, 1024, 1440],
  });


  componentDidMount() {
    window.addEventListener('resize', this.resizeCallback);
    //const interval = ConfigManager.getSportRefreshInterval(this.props.sportId) ? ConfigManager.getSportRefreshInterval(this.props.sportId) : 60000;
    //this.sportTimer = setInterval(this.getTeamCalendar, interval);
    this.getTeamCalendar();
    this.resizeCallback();
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.resizeCallback);
    /* if (this.sportTimer) {
      clearInterval(this.sportTimer);
    }*/
  }

  getTeamCalendar = () => {
    const {
      sportId, teamId, actions, widgetId,
    } = this.props;
    actions.getTeamCalendar(sportId, teamId, true, widgetId);
  };

  resizeCallback = () => {
    this.setState({
      isMobile: window.innerWidth <= 1023,
    });
  };

  render() {
    const {
      dictionary, calendars, sportId, widgetTitle, widgetId,
    } = this.props;
    const calendar = calendars.get(widgetId);
    const { isMobile } = this.state;
    const label = widgetTitle !== null ? widgetTitle : 'Calendario e risultati';
    return (
      <TeamCalendarWidgetWrapper
        isMobile={isMobile}
      >
        {label && <Label
          label={label}
          color="black"
          size={1.2}
          isTitleNarrowMedium
          margin="10px 0 20px"
        />
        }
        {calendar && calendar.get('calendar') && calendar.getIn(['calendar', 0]) && calendar.getIn(['calendar', 0, 'matches']) && calendar.getIn(['calendar', 0, 'matches']).map((match, index) => (
          <CalendarRow
            dictionary={dictionary}
            competitionId={match.get('competitionId')}
            isMobile={isMobile}
            matchRow={match}
            key={index}
            newspaper="gazzetta"
          />
        ))
        }
        {calendar && calendar.get('teamName') &&
          <StandingButton
            color="white"
            background="buttonColor"
            label="Vedi tutte"
            size="1.2"
            margin="26px 0 10px"
            linkTo={`${prettyTeamUrl(sportId, '21', process.env.REACT_APP_SITE, calendar.get('teamName'))}calendario-risultati/`}
          />
        }
      </TeamCalendarWidgetWrapper>
    );
  }
}

TeamCalendarWidget.propTypes = {
  actions: PropTypes.any,
  dictionary: PropTypes.any,
  sportId: PropTypes.any,
  teamId: PropTypes.any,
  calendars: PropTypes.any,
  widgetTitle: PropTypes.string,
  widgetId: PropTypes.any,
};

export default connect(
  state => ({
    dictionary: state.dictionaryReducer.dictionary,
    calendars: state.calendarReducer.get('calendars'),
  }),
  dispatch => ({
    actions: {
      initDictionary: () =>
        dispatch({ type: types.INIT_DICTIONARY }),
      getTeamCalendar: (sportId, teamId, isWidget, widgetId, seasonId) =>
        dispatch({
          type: types.GET_TEAM_CALENDAR_REQUEST,
          sportId,
          teamId,
          isWidget,
          widgetId,
          seasonId,
        }),
    },
  }),
)(TeamCalendarWidget);



// WEBPACK FOOTER //
// ./src/containers/TeamCalendarWidget/index.js